import {request} from '@api/index.js';
import urls from '@api/urls';
import {DURATION_MS, removeEmpty} from '@api/util.js';
import {useQuery} from '@tanstack/react-query';

// This magic number seems high enough to get all plans for most orgs
const PLAN_COUNT = 200;

// ---------------------------------------------------------------
// Plans

const getPlans = () =>
  request.get(`${urls.pdaAdmin}/my/subscriptions`).then(res => res.data);

export const useGetPlans = (queryOptions = {}) =>
  useQuery({
    queryKey: ['plans'],
    queryFn: () => getPlans(),
    ...queryOptions,
  });

// ---------------------------------------------------------------
// Products

const getProducts = params =>
  request
    .get(`${urls.pdaAdmin}/my/products/`, {
      params: {
        limit: PLAN_COUNT,
        quota_style: 'all',
        ...params,
      },
    })
    .then(res => res.data);

export const useGetProducts = (params = {}, queryOptions = {}) =>
  useQuery({
    queryKey: ['products', removeEmpty(params)],
    queryFn: () => getProducts(params),
    ...queryOptions,
  });

export const useGetProductsCount = (params = {}, queryOptions = {}) => {
  return useGetProducts(
    {
      ...params,
    },
    {
      staleTime: DURATION_MS.FIVE_MINUTES,
      select: data => data.meta.count,
      ...queryOptions,
    },
  );
};

// ---------------------------------------------------------------
// Tasking products

export const getTaskingContracts = ({orgId}) =>
  request
    .get(`${urls.pdaAdmin}/tasking/contracts/`, {
      params: {
        org_id: orgId,
        limit: PLAN_COUNT,
        offset: 0,
        automated_quota_enabled: true,
        state: 'ACTIVE',
      },
    })
    .then(res => res.data);

export const useGetTaskingContracts = ({orgId}, queryOptions = {}) =>
  useQuery({
    queryKey: ['tasking-contracts', orgId],
    queryFn: () => getTaskingContracts({orgId}),
    ...queryOptions,
  });
